// import React, { useState, useEffect } from 'react';

// const ProjectHistory = ({ project, onClose, authTokens }) => {
//   const [history, setHistory] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://ess-api-django-a6fc2c26f42e.herokuapp.com';

//   useEffect(() => {
//     fetchHistory();
//   }, [project.id]);

//   const fetchHistory = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch(`${API_BASE_URL}/api/timesheet/project-status/${project.id}/history/`, {
//         headers: {
//           Authorization: "Bearer " + String(authTokens.access),
//           'Content-Type': 'application/json',
//         },
//       });

//       if (!response.ok) {
//         throw new Error('Failed to fetch history');
//       }

//       const data = await response.json();
//       setHistory(data);
//       setError(null);
//     } catch (err) {
//       setError('Failed to load history');
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     return date.toLocaleString('en-US', {
//       month: 'short',
//       day: 'numeric',
//       year: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit'
//     });
//   };

//   const getStatusColor = (status) => {
//     const colors = {
//       'GOING_SMOOTH': '#10b981',
//       'ON_HOLD': '#f59e0b',
//       'CRITICAL': '#ef4444',
//       'CLOSED': '#6b7280'
//     };
//     return colors[status] || '#9ca3af';
//   };

//   const getStatusIcon = (status) => {
//     const icons = {
//       'GOING_SMOOTH': '✅',
//       'ON_HOLD': '⏸️',
//       'CRITICAL': '🚨',
//       'CLOSED': '✔️'
//     };
//     return icons[status] || '❓';
//   };

//   const styles = {
//     overlay: {
//       position: 'fixed',
//       top: 0,
//       left: 0,
//       right: 0,
//       bottom: 0,
//       backgroundColor: 'rgba(0, 0, 0, 0.5)',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       zIndex: 1000,
//       padding: '20px'
//     },
//     modal: {
//       backgroundColor: 'white',
//       borderRadius: '12px',
//       maxWidth: '800px',
//       width: '100%',
//       maxHeight: '90vh',
//       overflow: 'hidden',
//       display: 'flex',
//       flexDirection: 'column',
//       boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
//     },
//     header: {
//       padding: '24px',
//       borderBottom: '1px solid #e5e7eb',
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'flex-start'
//     },
//     headerContent: {
//       flex: 1
//     },
//     title: {
//       fontSize: '20px',
//       fontWeight: '600',
//       color: '#111827',
//       margin: '0 0 4px 0'
//     },
//     projectName: {
//       fontSize: '14px',
//       color: '#6b7280',
//       margin: 0
//     },
//     closeBtn: {
//       background: 'none',
//       border: 'none',
//       fontSize: '28px',
//       cursor: 'pointer',
//       color: '#6b7280',
//       lineHeight: '1',
//       padding: '0',
//       width: '32px',
//       height: '32px',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       borderRadius: '6px'
//     },
//     body: {
//       padding: '24px',
//       overflowY: 'auto',
//       flex: 1
//     },
//     loadingState: {
//       display: 'flex',
//       flexDirection: 'column',
//       alignItems: 'center',
//       justifyContent: 'center',
//       padding: '60px 20px',
//       gap: '16px'
//     },
//     spinner: {
//       width: '40px',
//       height: '40px',
//       border: '4px solid #f3f4f6',
//       borderTopColor: '#3b82f6',
//       borderRadius: '50%',
//       animation: 'spin 1s linear infinite'
//     },
//     errorState: {
//       display: 'flex',
//       flexDirection: 'column',
//       alignItems: 'center',
//       justifyContent: 'center',
//       padding: '60px 20px',
//       gap: '16px'
//     },
//     retryButton: {
//       padding: '8px 16px',
//       backgroundColor: '#3b82f6',
//       color: 'white',
//       border: 'none',
//       borderRadius: '6px',
//       cursor: 'pointer',
//       fontSize: '14px'
//     },
//     emptyState: {
//       textAlign: 'center',
//       padding: '60px 20px',
//       color: '#9ca3af'
//     },
//     timeline: {
//       position: 'relative'
//     },
//     timelineItem: {
//       display: 'flex',
//       gap: '16px',
//       marginBottom: '24px',
//       position: 'relative'
//     },
//     timelineMarker: (color) => ({
//       width: '40px',
//       height: '40px',
//       borderRadius: '50%',
//       backgroundColor: color,
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       fontSize: '18px',
//       flexShrink: 0,
//       position: 'relative',
//       zIndex: 1
//     }),
//     timelineContent: {
//       flex: 1,
//       backgroundColor: '#f9fafb',
//       borderRadius: '8px',
//       padding: '16px',
//       border: '1px solid #e5e7eb'
//     },
//     timelineHeader: {
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       marginBottom: '12px',
//       flexWrap: 'wrap',
//       gap: '8px'
//     },
//     statusBadge: (color) => ({
//       backgroundColor: color,
//       color: 'white',
//       padding: '4px 12px',
//       borderRadius: '12px',
//       fontSize: '12px',
//       fontWeight: '600'
//     }),
//     timelineDate: {
//       fontSize: '12px',
//       color: '#6b7280'
//     },
//     timelineBody: {
//       fontSize: '14px'
//     },
//     remarks: {
//       color: '#374151',
//       lineHeight: '1.5',
//       margin: '0 0 8px 0'
//     },
//     updatedBy: {
//       color: '#6b7280',
//       fontSize: '13px',
//       margin: 0
//     }
//   };

//   return (
//     <div style={styles.overlay} onClick={onClose}>
//       <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
//         <div style={styles.header}>
//           <div style={styles.headerContent}>
//             <h2 style={styles.title}>Project History</h2>
//             <p style={styles.projectName}>{project.project_name}</p>
//           </div>
//           <button 
//             style={styles.closeBtn}
//             onClick={onClose}
//             onMouseOver={(e) => e.target.style.backgroundColor = '#f3f4f6'}
//             onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}
//           >
//             &times;
//           </button>
//         </div>

//         <div style={styles.body}>
//           {loading && (
//             <div style={styles.loadingState}>
//               <div style={styles.spinner}></div>
//               <p>Loading history...</p>
//               <style>
//                 {`
//                   @keyframes spin {
//                     to { transform: rotate(360deg); }
//                   }
//                 `}
//               </style>
//             </div>
//           )}

//           {error && (
//             <div style={styles.errorState}>
//               <p>{error}</p>
//               <button 
//                 style={styles.retryButton}
//                 onClick={fetchHistory}
//                 onMouseOver={(e) => e.target.style.backgroundColor = '#2563eb'}
//                 onMouseOut={(e) => e.target.style.backgroundColor = '#3b82f6'}
//               >
//                 Retry
//               </button>
//             </div>
//           )}

//           {!loading && !error && history.length === 0 && (
//             <div style={styles.emptyState}>
//               <p>No status updates yet</p>
//             </div>
//           )}

//           {!loading && !error && history.length > 0 && (
//             <div style={styles.timeline}>
//               {history.map((item, index) => (
//                 <div key={item.id} style={styles.timelineItem}>
//                   <div style={styles.timelineMarker(getStatusColor(item.status))}>
//                     {getStatusIcon(item.status)}
//                   </div>
                  
//                   <div style={styles.timelineContent}>
//                     <div style={styles.timelineHeader}>
//                       <span style={styles.statusBadge(getStatusColor(item.status))}>
//                         {item.status_display}
//                       </span>
//                       <span style={styles.timelineDate}>
//                         {formatDate(item.created_at)}
//                       </span>
//                     </div>
                    
//                     <div style={styles.timelineBody}>
//                       <p style={styles.remarks}>{item.remarks}</p>
//                       <p style={styles.updatedBy}>
//                         Updated by <strong>{item.updated_by?.name || 'Unknown'}</strong>
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProjectHistory;


import React, { useState, useEffect, useContext } from 'react';
import AuthContext from "../contexts/AuthContext";

const ProjectHistory = ({ project, onClose, onEditStatus, authTokens }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user } = useContext(AuthContext);

  const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://ess-api-django-a6fc2c26f42e.herokuapp.com';

  useEffect(() => {
    fetchHistory();
  }, [project.id]);

  const fetchHistory = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}/api/timesheet/project-status/${project.id}/history/`, {
        headers: {
          Authorization: "Bearer " + String(authTokens.access),
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch history');
      }

      const data = await response.json();
      setHistory(data);
      setError(null);
    } catch (err) {
      setError('Failed to load history');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const canEditStatus = (statusItem) => {
    const userRole = user?.user_role || user?.role;
    
    // CEO and HR can edit any status
    if (userRole === 'CEO' || userRole === 'HR') {
      return true;
    }
    
    // Managers can only edit their own projects
    if (userRole === 'MANAGER') {
      const currentUserId = parseInt(user?.user_id || user?.id);
      const projectManagerId = parseInt(project.project_manager?.id);
      return currentUserId === projectManagerId;
    }
    
    return false;
  };

  const handleEdit = (statusItem) => {
    onClose();
    onEditStatus(project, statusItem);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusColor = (status) => {
    const colors = {
      'GOING_SMOOTH': '#10b981',
      'ON_HOLD': '#f59e0b',
      'CRITICAL': '#ef4444',
      'CLOSED': '#6b7280',
      'READY_TO_OUTSOURCE': '#8b5cf6'
    };
    return colors[status] || '#9ca3af';
  };

  const getStatusIcon = (status) => {
    const icons = {
      'GOING_SMOOTH': '✅',
      'ON_HOLD': '⏸️',
      'CRITICAL': '🚨',
      'CLOSED': '✔️',
      'READY_TO_OUTSOURCE': '🤝'
    };
    return icons[status] || '❓';
  };

  const getTaskStatusColor = (taskStatus) => {
    const colors = {
      'PENDING': '#f59e0b',
      'IN_PROGRESS': '#3b82f6',
      'COMPLETED': '#10b981',
      'BLOCKED': '#ef4444'
    };
    return colors[taskStatus] || '#9ca3af';
  };

  const styles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '20px'
    },
    modal: {
      backgroundColor: 'white',
      borderRadius: '12px',
      maxWidth: '900px',
      width: '100%',
      maxHeight: '90vh',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)'
    },
    header: {
      padding: '24px',
      borderBottom: '1px solid #e5e7eb',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start'
    },
    headerContent: {
      flex: 1
    },
    title: {
      fontSize: '20px',
      fontWeight: '600',
      color: '#111827',
      margin: '0 0 4px 0'
    },
    projectName: {
      fontSize: '14px',
      color: '#6b7280',
      margin: 0
    },
    closeBtn: {
      background: 'none',
      border: 'none',
      fontSize: '28px',
      cursor: 'pointer',
      color: '#6b7280',
      lineHeight: '1',
      padding: '0',
      width: '32px',
      height: '32px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '6px'
    },
    body: {
      padding: '24px',
      overflowY: 'auto',
      flex: 1
    },
    loadingState: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '60px 20px',
      gap: '16px'
    },
    spinner: {
      width: '40px',
      height: '40px',
      border: '4px solid #f3f4f6',
      borderTopColor: '#3b82f6',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite'
    },
    errorState: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '60px 20px',
      gap: '16px'
    },
    retryButton: {
      padding: '8px 16px',
      backgroundColor: '#3b82f6',
      color: 'white',
      border: 'none',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '14px'
    },
    emptyState: {
      textAlign: 'center',
      padding: '60px 20px',
      color: '#9ca3af'
    },
    timeline: {
      position: 'relative'
    },
    timelineItem: {
      marginBottom: '32px',
      position: 'relative'
    },
    timelineContent: {
      backgroundColor: '#f9fafb',
      borderRadius: '8px',
      padding: '20px',
      border: '1px solid #e5e7eb'
    },
    timelineHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '16px',
      flexWrap: 'wrap',
      gap: '12px'
    },
    statusBadge: (color) => ({
      backgroundColor: color,
      color: 'white',
      padding: '6px 14px',
      borderRadius: '12px',
      fontSize: '13px',
      fontWeight: '600',
      display: 'flex',
      alignItems: 'center',
      gap: '6px'
    }),
    editedBadge: {
      backgroundColor: '#fef3c7',
      color: '#92400e',
      padding: '4px 8px',
      borderRadius: '8px',
      fontSize: '11px',
      fontWeight: '600'
    },
    timelineDate: {
      fontSize: '13px',
      color: '#6b7280',
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },
    timelineBody: {
      fontSize: '14px'
    },
    remarks: {
      color: '#374151',
      lineHeight: '1.6',
      margin: '0 0 12px 0',
      padding: '12px',
      backgroundColor: 'white',
      borderRadius: '6px',
      border: '1px solid #e5e7eb'
    },
    linkSection: {
      marginTop: '12px',
      padding: '12px',
      backgroundColor: 'white',
      borderRadius: '6px',
      border: '1px solid #e5e7eb'
    },
    link: {
      color: '#3b82f6',
      textDecoration: 'none',
      fontSize: '13px',
      fontWeight: '500',
      display: 'flex',
      alignItems: 'center',
      gap: '6px'
    },
    tasksSection: {
      marginTop: '16px',
      padding: '16px',
      backgroundColor: 'white',
      borderRadius: '6px',
      border: '1px solid #e5e7eb'
    },
    sectionTitle: {
      fontSize: '14px',
      fontWeight: '600',
      color: '#111827',
      marginBottom: '12px'
    },
    taskItem: {
      padding: '10px',
      backgroundColor: '#f9fafb',
      borderRadius: '4px',
      marginBottom: '8px',
      fontSize: '13px'
    },
    taskHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '6px'
    },
    taskBadge: (color) => ({
      backgroundColor: color,
      color: 'white',
      padding: '2px 8px',
      borderRadius: '8px',
      fontSize: '11px',
      fontWeight: '600'
    }),
    taskDetails: {
      color: '#6b7280',
      fontSize: '12px',
      marginTop: '4px'
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      fontSize: '13px',
      marginTop: '8px'
    },
    tableHeader: {
      backgroundColor: '#f3f4f6',
      padding: '8px',
      textAlign: 'left',
      fontSize: '12px',
      fontWeight: '600',
      color: '#374151',
      borderBottom: '2px solid #e5e7eb'
    },
    tableCell: {
      padding: '8px',
      borderBottom: '1px solid #e5e7eb',
      color: '#374151'
    },
    updatedBy: {
      color: '#6b7280',
      fontSize: '13px',
      margin: '12px 0 0 0',
      fontStyle: 'italic'
    },
    actions: {
      display: 'flex',
      gap: '8px',
      marginTop: '12px'
    },
    editButton: {
      padding: '8px 16px',
      backgroundColor: '#3b82f6',
      color: 'white',
      border: 'none',
      borderRadius: '6px',
      fontSize: '13px',
      fontWeight: '500',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '6px'
    }
  };

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={styles.header}>
          <div style={styles.headerContent}>
            <h2 style={styles.title}>Project History</h2>
            <p style={styles.projectName}>{project.project_name}</p>
          </div>
          <button 
            style={styles.closeBtn}
            onClick={onClose}
            onMouseOver={(e) => e.target.style.backgroundColor = '#f3f4f6'}
            onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            &times;
          </button>
        </div>

        <div style={styles.body}>
          {loading && (
            <div style={styles.loadingState}>
              <div style={styles.spinner}></div>
              <p>Loading history...</p>
              <style>
                {`
                  @keyframes spin {
                    to { transform: rotate(360deg); }
                  }
                `}
              </style>
            </div>
          )}

          {error && (
            <div style={styles.errorState}>
              <p>{error}</p>
              <button 
                style={styles.retryButton}
                onClick={fetchHistory}
                onMouseOver={(e) => e.target.style.backgroundColor = '#2563eb'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#3b82f6'}
              >
                Retry
              </button>
            </div>
          )}

          {!loading && !error && history.length === 0 && (
            <div style={styles.emptyState}>
              <p>No status updates yet</p>
            </div>
          )}

          {!loading && !error && history.length > 0 && (
            <div style={styles.timeline}>
              {history.map((item) => (
                <div key={item.id} style={styles.timelineItem}>
                  <div style={styles.timelineContent}>
                    <div style={styles.timelineHeader}>
                      <span style={styles.statusBadge(getStatusColor(item.status))}>
                        {getStatusIcon(item.status)} {item.status_display}
                      </span>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {item.is_edited && (
                          <span style={styles.editedBadge}>
                            Edited ({item.edit_count}x)
                          </span>
                        )}
                        <span style={styles.timelineDate}>
                          {formatDate(item.created_at)}
                        </span>
                      </div>
                    </div>
                    
                    <div style={styles.timelineBody}>
                      <div style={styles.remarks}>{item.remarks}</div>

                      {/* File and Links */}
                      {(item.attachment_file_url || item.google_drive_link) && (
                        <div style={styles.linkSection}>
                          {item.attachment_file_url && (
                            <a 
                              href={item.attachment_file_url} 
                              target="_blank" 
                              rel="noopener noreferrer"
                              style={styles.link}
                            >
                              📎 View Attachment
                            </a>
                          )}
                          {item.google_drive_link && (
                            <a 
                              href={item.google_drive_link} 
                              target="_blank" 
                              rel="noopener noreferrer"
                              style={{...styles.link, marginTop: item.attachment_file_url ? '8px' : '0'}}
                            >
                              🔗 Open Google Drive Link
                            </a>
                          )}
                        </div>
                      )}

                      {/* Pending Tasks */}
                      {item.pending_tasks && item.pending_tasks.length > 0 && (
                        <div style={styles.tasksSection}>
                          <div style={styles.sectionTitle}>
                            📋 Pending Tasks ({item.pending_tasks.length})
                          </div>
                          {item.pending_tasks.map((task) => (
                            <div key={task.id} style={styles.taskItem}>
                              <div style={styles.taskHeader}>
                                <span><strong>#{task.sl_no}</strong> {task.task_description}</span>
                                <span style={styles.taskBadge(getTaskStatusColor(task.task_status))}>
                                  {task.task_status_display}
                                </span>
                              </div>
                              <div style={styles.taskDetails}>
                                <strong>Resource:</strong> {task.resource} • 
                                <strong> Due:</strong> {task.closing_date || 'Not set'}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}

                      {/* Outsource Resources */}
                      {item.outsource_resources && item.outsource_resources.length > 0 && (
                        <div style={styles.tasksSection}>
                          <div style={styles.sectionTitle}>
                            🤝 Outsource Resources ({item.outsource_resources.length})
                          </div>
                          <table style={styles.table}>
                            <thead>
                              <tr>
                                <th style={styles.tableHeader}>Name</th>
                                <th style={styles.tableHeader}>Roles</th>
                                <th style={styles.tableHeader}>Experience</th>
                                <th style={styles.tableHeader}>Projects</th>
                              </tr>
                            </thead>
                            <tbody>
                              {item.outsource_resources.map((resource) => (
                                <tr key={resource.id}>
                                  <td style={styles.tableCell}>{resource.resource_name}</td>
                                  <td style={styles.tableCell}>{resource.roles}</td>
                                  <td style={styles.tableCell}>{resource.years_of_experience} yrs</td>
                                  <td style={styles.tableCell}>{resource.projects_worked_on}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}

                      <p style={styles.updatedBy}>
                        Updated by <strong>{item.updated_by?.name || 'Unknown'}</strong>
                      </p>

                      {canEditStatus(item) && (
                        <div style={styles.actions}>
                          <button
                            style={styles.editButton}
                            onClick={() => handleEdit(item)}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#2563eb'}
                            onMouseOut={(e) => e.target.style.backgroundColor = '#3b82f6'}
                          >
                            ✏️ Edit
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectHistory;